import { NAME } from './constants';
import { router } from './router';

export const WmsTechnician = {
	name: NAME,
	router,
};
